module.exports = __webpack_public_path__ + "lomovykamen.jpg?bc137d3385d975b9faa76d113f12515c";


//////////////////
// WEBPACK FOOTER
// ./src/assets/materialy/lomovykamen.jpg
// module id = 83
// module chunks = 0